<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Main from '@/components/Main'

export default {
  name: 'app',

  methods: {
    ...mapActions([
      'loadMenuItems',
      'loadProgramItems'
    ])
  },

  components: {
    Main
  },

  created: function () {
    this.loadMenuItems()
    this.loadProgramItems()
  }
}

</script>

<style>
@import 'style/global.css';
</style>
